import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './Route.jsx';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <main>
          <AppRoutes />
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;